import React from 'react';
import { Header } from '../components/Header';
import { ApproachSection } from '../components/ApproachSection';
import { BeliefSection } from '../components/BeliefSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2556">
      <Header data-id="element-2557" />
      <main data-id="element-2558">
        <ApproachSection data-id="element-2559" />
        <BeliefSection data-id="element-2560" />
        <ServicesSection data-id="element-2561" />
        <WhyChooseUsSection data-id="element-2562" />
        <TestimonialsSection data-id="element-2563" />
        <ContactForm data-id="element-2564" />
      </main>
      <Footer data-id="element-2565" />
    </div>;
}